import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { InputHTMLAttributes, useState } from "react";
import { useDebounceCallback } from "@/hooks";
import { useSearchParams } from "react-router-dom";

import styles from "./SearchField.tsx.module.css";

export type SearchFieldProps = {
  onSearch?: (searchString?: string) => void;
};

export function SearchField({ onSearch, ...props }: SearchFieldProps & InputHTMLAttributes<HTMLDivElement>) {
  const [searchParams, setSearchParams] = useSearchParams();
  const [searchString, setSearchString] = useState(() => {
    return searchParams.get("search") ?? "";
  });

  const debouncedSearch = useDebounceCallback(search, 300);

  function handleSearchChanged(search: string) {
    setSearchString(search);
    debouncedSearch(search);
  }

  function search(search: string) {
    const params = new URLSearchParams(searchParams.toString());
    params.set("search", search);
    setSearchParams(params);
  }

  return (
    <div className={styles.search}>
      <div className="input-group" {...props}>
        <input
          type="text"
          className="form-control"
          placeholder="Search..."
          value={searchString}
          onChange={(e) => handleSearchChanged(e.currentTarget.value)}
        />
        <span className="input-group-text">
          <FontAwesomeIcon
            size="sm"
            role="button"
            icon={faMagnifyingGlass}
            title="Search"
            onClick={() => onSearch?.(searchString)}
          />
        </span>
      </div>
    </div>
  );
}
